<template>
  <div id="myOrder">
    <div class="top">
      <ul class="topL">
        <span v-for="(item, index) in navList" :key="index">
          <el-badge :value="item.count == 0 ? '' : item.count" class="item">
            <li :class="{ 'active': i == index }" @click="tab(index, item.type)">{{ item.name }}
              <span class="num" v-if="index != 0">{{ item.num }}</span>
            </li>
          </el-badge>
        </span>
      </ul>
      <el-input placeholder="输入单号搜索..." v-model="searchVal" @keyup.enter.native="onEnterSearch" class="query">
        <i slot="prefix" class="el-input__icon el-icon-search" @click="search()"></i>
      </el-input>
    </div>
    <ul class="titl">
      <li class="titl1 titl11">商品</li>
      <li class="titl2 titl12">单价</li>
      <li class="titl3 titl13">数量</li>
      <li class="titl4 titl14">实付款</li>
      <li class="titl5 titl15">交易状态</li>
      <li class="titl6 titl16">交易操作</li>
    </ul>
    <div class="listWrap">
      <div class="lists" v-for="(item, index) in DataList" :key="index">
        <table cellspacing="0">
          <thead v-if="allFlag">
            <tr>
              <th>
                <span class="data">{{ item.updateDate }}</span>
              </th>
              <th colspan="2">
                <span class="hao">订单号：</span>
                <span class="hao2">{{ item.id }}</span>
              </th>
              <th colspan="3">
                <!--  <p class="right">
                  <span>联系客服：</span>
                  <span class="numb">{{kf}}</span>
                  <i
                    class="el-icon-delete"
                    v-show="item.optDdzt == 1 ||item.optDdzt == 10"
                    @click="del(item.id)"
                  ></i>
                  <template v-if="item.endtime != 0"><i class="el-icon-time"></i> {{item.endtime}}</template>
</p> -->
              </th>
            </tr>
          </thead>
          <thead v-if="dfk">
            <tr>
              <th>
                <span class="data">{{ item.updateDate }}</span>
              </th>
              <th colspan="2">
                <span class="hao">订单号：</span>
                <span class="hao2">{{ item.id }}</span>
              </th>
              <th colspan="3">
                <p class="right">
                  <span>联系客服：</span>
                  <span class="numb">{{ kf }}</span>
                  <i class="el-icon-delete" v-show="item.optDdzt == 1 || item.optDdzt == 10" @click="del(item.id)"></i>
                  <template v-if="item.endtime != 0"> <i class="el-icon-time"></i>{{ item.endtime }}</template>
                </p>
              </th>
            </tr>
          </thead>
          <tbody v-if="item.atType == 1">
            <tr v-for="(item2, index2) in item.ddmxList" :key="index2">
              <td class="titl1">
                <div class="imgs" @click="goShopDetail(item2.spSpgl,item2)">
                  <div class="xia" v-if="item2.spDeletedFlag!=0 || item2.optSjzt != 1">
                    <div class="xiaText">已下架</div>
                  </div>
                  <img :src="$store.state.imgUrl + item2.atPhotoUrl" alt />
                </div>
                <!-- 普通订单 -->
                <p v-if="item.atType == 1" @click="goShopDetail(item2.spSpgl,item2)">{{ item2.atSpmc }} - {{ item2.standard }}</p>
              </td>
              <td class="titl2">
                <div v-if="item2.optYhlx != 3">
                  <p class="text1">￥{{ item2.atSpje }}/{{ item2.unit }}{{ item2.unitByDefault ? '(' + item2.unitByDefault + ')' : '' }}</p>
                  <p class="text2">￥{{ item2.atYjje }}/{{ item2.unit }}{{ item2.unitByDefault ? '(' + item2.unitByDefault + ')' : '' }}</p>
                </div>
                <div class="li3-l" v-if="item2.optYhlx == 3">
                  <p class="text1">
                    ￥{{ item2.atYjje }}/{{ item2.unit }}{{ item2.unitByDefault ? '(' + item2.unitByDefault + ')' : '' }}</p>
                </div>
              </td>
              <td class="titl3">X{{ item2.atSpsl }}</td>
              <!-- <td class="titl4">￥{{ item2.atSpje }}</td> -->
              <td class="titl4">￥{{ multiplication(item2.atSpje, item2.atSpsl) }}</td>
              <td class="titl5" v-if="index2 == 0" :rowspan="item.ddmxList.length">
                <p class="p1"> {{ item.optDdzt === 0 ? '等待付款'
                  : item.optDdzt === 1 ? '交易关闭'
                    : item.optDdzt === 3 ? '等待发货'
                      : item.optDdzt === 4 ? '等待收货'
                        : item.optDdzt === 5 ? '等待评价'
                          : item.optDdzt === 6 ? '退单中'
                            : item.optDdzt === 7 ? '退单成功'
                              : item.optDdzt === 9 ? '已开发票'
                                : item.optDdzt === 10 ? '已完成'
                                  : item.optDdzt === 11 ? '待回复'
                                    : item.optDdzt === 12 ? '待用户确认'
                                     : item.optDdzt === 13 ? '医师拒绝'
                                      : item.optDdzt === 14 ? '部分退款'
                                        : '未知状态' }}</p>
              </td>
              <td class="titl6" v-if="index2 == 0" :rowspan="item.ddmxList.length">
                <p class="p1 shou" @click="goDetails(item.id)">订单详情</p>
                <!-- 待支付 -->
                <p class="p1 shou" v-if="item.optDdzt == 0 || item.endtime != 0" @click="cancel(item.id)">取消订单</p>
                <p class="p1 shou" v-if="item.optDdzt == 0" @click="payment(item.id)">立即付款</p>
                <!-- 待收货 -->
                <p class="p1 shou" v-if="item.optDdzt == 4" @click="logistics(item.id)">查看物流</p>
                <p class="p1 shou" v-if="item.optDdzt == 4" @click="ConfirmReceipt(item.id)">确认收货</p>
                <!-- 等待评价 -->
                <p class="p1 shou" v-if="item.optDdzt == 5 && item.optDdzt != 10"
                  @click="evaluate(item.id, item2.spSpgl)">立即评价</p>
                <p class="p1 shou" v-if="item.optDdzt == 5 || item.optDdzt == 10 || item.optDdzt == 1"
                  @click="Repurchase(item.id, item.atType)">再次购买</p>
              </td>
            </tr>
          </tbody>
          <tbody v-if="item.atType == 2">
            <tr>
              <td class="titl1">
                <div class="imgs" @click="goDetailsCF(item.id)">
                  <img src="@/assets/img/fangji.png" alt />
                </div>
                <!-- 处方订单 -->
                <p @click="goDetailsCF(item.id)">{{ item.cfName }}</p>
              </td>
              <td class="titl2"></td>
              <td class="titl3">X{{ item.atSpzsl }}</td>
              <td class="titl4">￥{{ item.atSpzje }}</td>
              <td class="titl5">
                <p class="p1"> {{ item.optDdzt === 0 ? '等待付款'
                  : item.optDdzt === 1 ? '交易关闭'
                    : item.optDdzt === 3 ? '等待发货'
                      : item.optDdzt === 4 ? '等待收货'
                        : item.optDdzt === 5 ? '等待评价'
                          : item.optDdzt === 6 ? '退单中'
                            : item.optDdzt === 7 ? '退单成功'
                              : item.optDdzt === 9 ? '已开发票'
                                : item.optDdzt === 10 ? '已完成'
                                  : item.optDdzt === 11 ? '待回复'
                                    : item.optDdzt === 12 ? '待用户确认'
                                     : item.optDdzt === 13 ? '医师拒绝'
                                      : item.optDdzt === 14 ? '部分退款'
                                        : '未知状态' }}</p>
              </td>
              <td class="titl6">
                <p class="p1 shou" @click="goDetailsCF(item.id)">订单详情</p>
                <!-- 待支付 -->
                <p class="p1 shou" v-if="item.optDdzt == 0 || item.endtime != 0" @click="cancel(item.id)">取消订单</p>
                <p class="p1 shou" v-if="item.optDdzt == 0" @click="payment(item.id)">立即付款</p>
                <!-- 待收货 -->
                <p class="p1 shou" v-if="item.optDdzt == 4" @click="logistics(item.id)">查看物流</p>
                <p class="p1 shou" v-if="item.optDdzt == 4" @click="ConfirmReceipt(item.id)">确认收货</p>
                <!-- 等待评价 -->
                <p class="p1 shou" v-if="item.optDdzt == 5 && item.optDdzt != 10"
                  @click="evaluateCF(item.id, item.spSpgl)">立即评价
                </p>
                <!-- <p
                  class="p1 shou"
                  v-if="item.optDdzt == 5"
                  @click="Repurchase(item.id,item.atType)"
                >再次购买</p> -->
                <!-- 成功 -->

              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="page">
        <el-pagination background layout="prev, pager, next" :total="DataListAll.total" :page-size="pageSize"
          :current-page.sync="pageNum" @size-change="handleSizeChange"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>

  </div>
</template>
<script>

var interval = null
export default {
  name: "Shopping",
  data() {
    return {
      userId: "",
      checked: true,
      value1: null,
      desc: "",
      radio1: "",
      radio2: "",
      searchVal: "", //查询框数据
      searchFlag: false, //用于判断是否有查询条件
      pageSize: 10, //分页每页显示条数
      pageNum: 1, //当前页码
      i: 0,
      navList: [
        {
          name: "全部订单",
          type: "",
          count: 0,
          num: ""
        },
        {
          name: "待付款",
          type: 0,
          count: 0,
          num: ""
        },
        {
          name: "待发货",
          type: 3,
          count: 0,
          num: ""
        },
        {
          name: "待收货",
          type: 4,
          count: 0,
          num: ""
        },
        {
          name: "待评价",
          type: 5,
          count: 0,
          num: ""
        },
        {
          name: "已完成",
          type: 10,
          count: 0,
          num: ""
        }
      ],
      checkboxs: [],
      DataListAll: [], //返回的所有数据
      DataList: [], //渲染列表所需数据
      //optDdzt: "",//全部订单状态
      kf: "13897237165", //客服电话
      // minute: 59, // 分钟
      // second: 59, // 秒
      dfk: false,
      allFlag: true
    };
  },
  components: {},
  created() {
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userId = this.userInfo.id;
    }
    if (sessionStorage.getItem("orderIndex")) {
      //获取
      this.i = sessionStorage.getItem("orderIndex");
    }
    this.getData();
    // this.getNumber();
    this.getnum();
  },
  // mounted () {
  //   this.$nextTick(()=>{
  //     this.add()
  //   })
  // },

  destroyed() {
    clearInterval(interval)
  },
  methods: {
    getnum() {
      var params = {};
      params.createBy = this.userId;
      let url = "ddgl/getDdglCount";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          this.navList[1].num = res.data.data.dzfCount;
          this.navList[2].num = res.data.data.dfhCount;
          this.navList[3].num = res.data.data.dshCount;
          this.navList[4].num = res.data.data.dpjCount;
          this.navList[5].num = res.data.data.ywcCount;
          // this.kf = res.data.data.atPhone;
        }
      });
    },
    getData() {
      var params = {};
      params.createBy = this.userId;
      // 判断optDdzt状态
      this.i = this.i.toString();
      switch (this.i) {
        case "0":
          params.optDdzt = "";
          break;
        case "1":
          params.optDdzt = 0;
          break;
        case "2":
          params.optDdzt = 3;
          break;
        case "3":
          params.optDdzt = 4;
          break;
        case "4":
          params.optDdzt = 5;
          break;
        case "5":
          params.optDdzt = 10;
          break;
      }
      if (this.searchFlag) {
        params.search = this.searchVal;
      }
      params.pageSize = this.pageSize;
      params.pageNum = this.pageNum;
      let url = "/ddgl/getAppIndexListV2";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res);
          if (this.searchFlag) {
            this.searchFlag = false;
            this.searchVal = "";
          }
          this.DataListAll = res.data.data;
          this.DataList = res.data.data.list;
          for (var i = 0; i < this.DataList.length; i++) {
            this.DataList[i].updateDate = this.getTime(
              this.DataList[i].updateDate
            );

            this.$set(this.DataList[i], 'endtime', 0)


          }


          if (params.optDdzt === 0 || params.optDdzt == '') {
            // this.countdown();
            //this.add();
            clearInterval(interval)
            this.setFn()
          }
        }
      });
    },
    // getNumber() {
    //   var params = {};
    //   let url = "/kfgl/getSave";
    //   this.$http.post(url, params).then(res => {
    //     if (res.data.code == 200) {
    //       // console.log(res, 564);
    //       this.kf = res.data.data.atPhone;
    //     }
    //   });
    // },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getData();

      clearInterval(interval)
    },
    tab(index, type) {
      if (type === 0) {
        this.dfk = true;
        this.allFlag = false;
      } else {
        this.dfk = false;
        this.allFlag = true;
      }
      this.i = index;
      //this.optDdzt = type;
      this.pageNum = 1;
      this.getData();
      sessionStorage.setItem("orderIndex", index);
    },
    onEnterSearch: function (e, searchVal) {
      //input回车
      this.search();
    },
    search() {
      //搜索
      this.searchFlag = true;
      this.getData();
    },
    del(id) {
      //删除
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var params = {};
        params.username = this.userId;
        params.id = id;
        let url = "/ddgl/delete";
        this.$http.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getData();
            this.getnum();
          }
        });
      });
    },
    cancel(id) {
      //取消订单
      this.$confirm("此操作将取消该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var params = {};
        params.id = id;
        let url = "/ddgl/qxUpdate";
        this.$http.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "取消成功!"
            });
            this.getData();
            this.getnum();
          }
        });
      });
    },
    ConfirmReceipt(id) {
      //确认收货
      var params = {};
      params.id = id;
      let url = "/ddgl/qrshUpdate";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "确认收货成功!"
          });
          this.getData();
          this.getnum();
        }
      });
    },
    Repurchase(id, atType) {
      //再次购买
      this.$confirm("是否再次购买该订单下的所有商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var params = {};
        params.id = id;
        let url = "/ddgl/againPayV2";
        this.$http.post(url, params).then(res => {
          if (res.data.code == 200) {
            if (atType == 1) {//订单类型 1：普通订单 2：处方订单
              let data = {};
              data.userId = this.userId;
              let list = res.data.data.spgl;
              var arr = [];
              for (var i = 0; i < list.length; i++) {
                arr.push({
                  spSpgl: list[i].id,
                  atSpsl: list[i].atSpsl,
                  spSpgg: list[i].spSpgg, //规格的id
                  spSpggDetail: list[i].spSpggDetail, //规格明细的id
                  isWholesale: list[i].atSpsl > list[i].wholesaleCount || list[i].atSpsl == list[i].wholesaleCount ? 1 : 0,//是否批发 0：否，1：是
                  spYhxx: list[i].optYhlx == 1 ? list[i].yhxxId : null
                });
              }
              data.ddmxList = arr;
              sessionStorage.setItem("ddmxList", JSON.stringify(data)); //存储获取订单所需数据
              this.$router.push({
                path: "/ReceivingAddress",
                query: { type: 1 } //type:生成订单入口区分（0 商品详情生成订单 1：购物车生成订单）
              });
            } else if (atType == 2) {
              this.$router.push({
                path: "/ReceivingAddress2",
                query: { id: res.data.data.prescription.id } //type:生成订单入口区分（0 商品详情生成订单 1：购物车生成订单）
              });
            }
          } else {
            this.$message(res.data.msg);
          }
        });
      });
    },
    evaluate(id, spSpgl) {
      //商品评价
      this.$router.push({
        path: "/evaluate",
        query: { id: id, spSpgl: spSpgl }
      }); //传输订单明细id+商品id
    },
    evaluateCF(id, spSpgl) {
      //药方评价
      this.$router.push({
        path: "/evaluateCf",
        query: { id: id, spSpgl: spSpgl }
      }); //传输订单明细id+商品id
    },
    payment(id) {
      //支付
      this.$router.push({ path: "/payment", query: { id: id } });
    },
    logistics(id) {
      //查看物流
      this.$router.push({ path: "/logistics", query: { id: id } });
    },
    goDetails(id) {
      this.$router.push({ path: "/OrderDetails", query: { id: id } });
    },
    goDetailsCF(id) {
      this.$router.push({ path: "/OrderCFDetails", query: { id: id } });
    },
    again(id) {
      this.$router.push({
        path: "/ReceivingAddress",
        query: { type: 0, spSpgl: id, atSpsl: this.num }
      });
    },
    goShopDetail(id,item) {
      if (item.spDeletedFlag != 0 || item.optSjzt != 1) {
        this.$message({
              message: "该商品已下架~"
            });
				} else {
          this.$router.push({ path: "/ProductDetails/" + id });
        }
     
    },
    num(n) {
      return n < 10 ? "0" + n : "" + n;
    },
    add() {
      var _this = this;
      var time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          window.clearInterval(time);
        } else {
          _this.seconds -= 1;
        }
      }, 1000);
    },
    //倒计时
    // countdown() {
    //   for (var i = 0; i < this.DataList.length; i++) {
    //     const end = Date.parse(
    //       new Date(this.DataList[i].scheduledCreateDateEnd)
    //     );
    //     const now = Date.parse(new Date());
    //     const msec = end - now;
    //     console.log(msec);
    //     if (msec < 0) return;
    //     let day = parseInt(msec / 1000 / 60 / 60 / 24);
    //     let hr = parseInt((msec / 1000 / 60 / 60) % 24);
    //     let min = parseInt((msec / 1000 / 60) % 60);
    //     let sec = parseInt((msec / 1000) % 60);
    //     this.day = day;
    //     this.hr = hr > 9 ? hr : "0" + hr;
    //     this.min = min > 9 ? min : "0" + min;
    //     this.sec = sec > 9 ? sec : "0" + sec;
    //     const that = this;
    //     if (min >= 0 && sec >= 0) {
    //       //倒计时结束关闭订单
    //       if (min == 0 && sec == 0) {
    //         return;
    //       }
    //       for (var i = 0; i < this.time.length; i++) {
    //         this.time[i].min = this.min
    //       this.time[i].sec = this.sec
    //       }
    //       // this.time.min = this.min
    //       // this.time.sec = this.sec
    //       console.log(this.time)
    //       // console.log(this.sec)
    //       // setTimeout(function() {
    //       //   that.countdown();
    //       // }, 1000);
    //     }
    //   }
    // }

    setFn() {
      let that = this
      var oldPin = that.DataList;

      interval = setInterval(() => {
        for (var i = 0; i < oldPin.length; i++) {
          var enddate = Date.parse(oldPin[i].scheduledCreateDateEnd) / 1000;
          var nowdate = Date.parse(new Date()) / 1000;
          // console.log(enddate)

          var second = enddate - nowdate;
          // var second = 1559254131 - nowdate;
          if (second > 0) {
            // 天数位
            var day = Math.floor(second / 3600 / 24);
            var dayStr = day.toString();
            if (dayStr.length == 1) dayStr = '0' + dayStr;

            // 小时位
            var hr = Math.floor((second - day * 3600 * 24) / 3600);
            var hrStr = hr.toString();
            if (hrStr.length == 1) hrStr = '0' + hrStr;

            // 分钟位
            var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60);
            var minStr = min.toString();
            if (minStr.length == 1) minStr = '0' + minStr;

            // 秒位
            var sec = second - day * 3600 * 24 - hr * 3600 - min * 60;
            var secStr = sec.toString();
            if (secStr.length == 1) secStr = '0' + secStr;

            //oldPin[i]['endtime'] = dayStr + '天' + hrStr + '时' + minStr + '分' + secStr + '秒'

            let dd = minStr + '分' + secStr + '秒'
            that.DataList[i]['endtime'] = dd
          } else {
            that.DataList[i]['endtime'] = 0

          }
        }
      }, 1000)
    }
  },
  watch: {
    second: {
      handler(newVal) {
        this.num(newVal)
      }
    },
    minute: {
      handler(newVal) {
        this.num(newVal)
      }
    }
  },
  computed: {
    second() {
      return this.num(this.seconds)
    },
    minute() {
      return this.num(this.minutes)
    }
  }
};
</script>
<style scoped>
.page {
  /* position: fixed;
  bottom: 30px;
  background-color: #f6f6f6;
  width: 54%; */
}

#myOrder {
  width: 99.8%;
}

#myOrder::after {
  content: "";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
  overflow: hidden;
}

.listWrap {
  width: 100%;
  /* height: 800px; */
  overflow-y: auto;
  margin-bottom: 90px;
}

/* .listWrap::after {
  content: "";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
  overflow: hidden;
} */
.top {
  width: 100%;
  height: 46px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
}

.topL {
  float: left;
  width: 66%;
  margin-left: 20px;
}

.topL li {
  float: left;
  width: 80px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  margin-right: 10px;
  font-size: 14px;
  letter-spacing: 0px;
  color: #333333;
  cursor: pointer;
  position: relative;
}

.topL li.active {
  color: #f64420;
  border-bottom: 3px solid #f64420;
}

.topL li .num {
  position: absolute;
  top: 5px;
  right: 0;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  border-radius: 5px;
  color: #fff;
  background: #f64420;

}

.topR {
  float: rigth;
  width: 34%;
}

.query {
  width: 250px;
  height: 32px;
  margin: 6px 0 0 10px;
}

.titl {
  width: 100%;
  height: 46px;
  margin-top: 10px;
}

.titl li {
  float: left;
  height: 46px;
  line-height: 46px;
  text-align: center;
  font-size: 13px;
  letter-spacing: 1px;
  color: #777777;
}

.titl1 {
  /* width: 28%; */
  width: 240px;
  box-sizing: border-box;
  padding-left: 10px;
}

.titl11 {
  width: 241px;
}

.titl2 {
  /* width: 19.5%; */
  width: 165px;
  text-align: center;
}
.text2{
  color: #777;
  text-decoration: line-through;
}
.titl12 {
  width: 168px;
}

.titl3 {
  /* width: 10%; */
  width: 84px;
  text-align: center;
}

.titl13 {
  width: 87px;
}

.titl4 {
  /* width: 9.8%; */
  width: 84px;
  text-align: center;
}

.titl14 {
  width: 87px;
}

.titl5 {
  /* width: 19.4%; */
  width: 86px;
  text-align: center;
}

.titl15 {
  width: 89px;
}

.titl6 {
  /* width: 10%; */
  width: 159px;
  text-align: center;
}

.title16 {
  width: 162px;
}

.lists {
  width: 99%;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  margin-bottom: 20px;
}

.lists::after {
  content: "";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
  overflow: hidden;
}

.listTop {
  width: 100%;
  height: 36px;
  background-color: #f0f0f0;
  border-bottom: solid 1px #dddddd;
}

table {
  width: 100%;
}

thead i {
  float: left;
  display: block;
  width: 36px;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  font-size: 14px;
  cursor: pointer;
}

thead i.el-icon-delete {
  margin-left: 60px;
}

thead {
  width: 100%;
  height: 36px;
  background-color: #f0f0f0;
  border-bottom: solid 1px #dddddd;
  font-weight: normal;
}

thead th {
  padding: 0;
  font-weight: normal;
  border: none;
}

thead th:nth-of-type(1) {
  text-indent: 10px;
}

thead span {
  display: block;
  float: left;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
}

.listTop .data {
  margin-left: 10px;
}

thead .hao {
  margin-left: 20px;
}

thead .numb {
  font-weight: normal;
  letter-spacing: 1px;
  color: #f64420;
}

.right {
  float: left;
  line-height: 36px;
}

tbody td {
  border-right: solid 1px #dddddd;
}

tbody tr {
  border-bottom: solid 1px #dddddd;
}

.listMain {
  width: 100%;
  height: 92px;
  background-color: #ffffff;
}

.listMain ul {
  width: 100%;
  height: 92px;
  border-top: 1px solid #dddddd;
}

.listMain ul li {
  float: left;
  height: 92px;
  border-right: solid 1px #dddddd;
  letter-spacing: 1px;
  color: #999999;
  font-size: 13px;
  line-height: 92px;
  text-align: center;
}

.listMain ul .titl1 {
  box-sizing: border-box;
  padding: 10px;
}

.listMain ul .titl5 p {
  height: 20px;
  line-height: 20px;
}

.listMain ul .titl5 .p1 {
  color: #333333;
  margin-top: 20px;
}

.listMain ul .titl5 .p2 {
  color: #333333;
  margin-top: 20px;
  cursor: pointer;
}

.listMain ul .titl5 .p2:hover {
  color: #f64420;
}

.listMain ul .titl6 p {
  height: 20px;
  line-height: 20px;
}

.listMain ul .titl6 .p1 {
  width: 60px;
  height: 24px;
  line-height: 24px;
  background-color: #f8f8f8;
  border-radius: 2px;
  font-size: 13px;
  border: solid 1px #dddddd;
  margin: 5px auto 0;
  cursor: pointer;
}

.listMain ul .titl6 .p1.active {
  background-color: #f64420;
  color: #fff;
}

.listMain ul .titl6 .p2 {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 19px;
  letter-spacing: 1px;
  color: #333333;
  cursor: pointer;
}
.titl1 {
  position: relative;
}
.titl1 .imgs {
  float: left;
  width: 84px;
  height: 60px;
  overflow: hidden;
  margin-top: 5px;
  cursor: pointer;
}
.xia{
position: absolute;
top:5px;
left:10px;
width: 84px;
height: 60px;
background: rgba(255,255,255,.5);
display: flex;
justify-content: center;
align-items: center;
}
.xiaText{
  box-sizing: border-box;
  padding: 5px;
  background: rgba(255,255,255,.5);
}

.titl1 .imgs img {
  width: 100%;
  min-height: 100%;
}

.titl1 p {
  float: left;
  width: 125px;
  height: 65px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 18px;
  letter-spacing: 1px;
  color: #333333;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}

.titl1 p:hover {
  color: #f64420;
}

.titl6 p {
  width: 60px;
  height: 24px;
  line-height: 24px;
  background-color: #f8f8f8;
  border-radius: 2px;
  border: solid 1px #dddddd;
  margin: 0 auto;
  margin-bottom: 5px;
}

.titl6 p:last-child {
  margin-bottom: 0px;
}
</style>

<style>
#myOrder .el-input__inner {
  height: 32px;
  line-height: 32px;
}

#myOrder .el-input__icon {
  line-height: 32px;
}

#myOrder .el-checkbox {
  float: left;
  margin-top: 10px;
  margin-left: 10px;
}

#myOrder .el-checkbox__label {
  display: none;
}

#myOrder .el-pagination {
  padding: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Orderlist/myOrder.vue